<select class="form-control pa-2 border mt-1" (change)="shopTypeChange($event)" [(ngModel)]="shopType">
  <option value="W">{{ 'FOR_WORKSHOP' | translate }}</option>
  <option value="S">{{ 'FOR_SHOP' | translate }}</option>
  <option value="X">{{ 'FOR_SHOP' | translate }} ({{ 'SOLD'.toLowerCase() | translate }})</option>
</select>
